__turbopack_context__.v({
  "shimmer": "MFHFJa_shimmer",
  "skeleton": "MFHFJa_skeleton",
});
